/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChargingSessions } from '../../models/charging-sessions';

export interface ApiChargingSessionsParkingSpotsParkingPlaceIdGet$Json$Params {
  parkingPlaceId: number;
}

export function apiChargingSessionsParkingSpotsParkingPlaceIdGet$Json(http: HttpClient, rootUrl: string, params: ApiChargingSessionsParkingSpotsParkingPlaceIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ChargingSessions>>> {
  const rb = new RequestBuilder(rootUrl, apiChargingSessionsParkingSpotsParkingPlaceIdGet$Json.PATH, 'get');
  if (params) {
    rb.path('parkingPlaceId', params.parkingPlaceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ChargingSessions>>;
    })
  );
}

apiChargingSessionsParkingSpotsParkingPlaceIdGet$Json.PATH = '/api/ChargingSessions/parkingSpots/{parkingPlaceId}';
